module.exports = __webpack_public_path__ + "img/diem_danh.3690f0b7.svg";